module.exports = __webpack_public_path__ + "img/palm-room.104f4be2.jpg";